/**
 * @file 加盟員番号タイプ変更
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ChangeMemberIdType
 * @classdesc 加盟員番号タイプ変更
 */
export default class ChangeMemberIdType {
	/**
	 * @constructor
	 * @param {jQuery} $e - #change_member_id_type
	 */
	constructor($e) {
		console.log('ChangeMemberIdType.constructor');
		this._$e = $e;
		$('#member_id');
		$e.on('click', () => this.onClick());
		this.onClick();
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeMemberIdType
	 * @return {undefined}
	 */
	onClick() {
		console.log('ChangeMemberIdType.onClick');
		console.log(this._$e.prop('checked'))
		const $memberId = $('#member_id');
		if(this._$e.prop('checked')){
			$memberId
				.removeClass('is-invalid')
				.attr('maxlength', '10')
				.attr('data-validate', 'number nospace nosymbol len-10')
				.closest('.form-group')
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.html('')
			let val = $memberId.val();
			if (val.length === 11) {
				val = val.substring(0,10);
				$memberId.val(val)
			}
		} else {
			$memberId
				.removeClass('is-invalid')
				.attr('maxlength', '11')
				.attr('data-validate', 'memberid number nospace nosymbol len-11')
				.closest('.form-group')
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.html('')
		}
	};
}
